import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api'; // adjust as needed
import { toast } from 'react-toastify';
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // <-- ADDED
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatDateOnly } from '../../utils/notificationUtils';

function HolidayListPage() {
  const navigate = useNavigate();
  const [holidays, setHolidays] = useState([]);

  const fetchHolidays = async () => {
    try {
      const res = await api.get('/holidays'); // GET /holidays
      setHolidays(res.data);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch holidays');
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this holiday?')) {
      return;
    }
    try {
      await api.delete(`/admin/holidays/${id}`); // DELETE /holidays/:id
      toast.success('Holiday deleted successfully!');
      fetchHolidays(); // re-fetch the list
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete holiday. Please try again.');
    }
  };

  const handleEdit = (id) => {
    navigate(`/admin/holidays/edit/${id}`);
  };

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 3 }}>
      {/* Top Bar with Title + Back Button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Typography variant="h5" gutterBottom>
          Holidays
        </Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
        onClick={() => navigate('/admin/holidays/new')}
      >
        Add New Holiday
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Active?</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {holidays.map((holiday) => (
            <TableRow key={holiday.id}>
              <TableCell>{holiday.name}</TableCell>
              <TableCell>{formatDateOnly(holiday.holiday_date)}</TableCell>
              <TableCell>{holiday.is_active ? 'Yes' : 'No'}</TableCell>
              <TableCell>
                <IconButton color="primary" onClick={() => handleEdit(holiday.id)}>
                  <EditIcon />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(holiday.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}

          {holidays.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No holidays found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}

export default HolidayListPage;
